import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingUnitActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Unit/UnitBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchasingUnit"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingUnit"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingUnitActivity)
